import {AllowedLanguages, DefaultLang} from "./config";


const getUserLang = () => {
    const userLang = navigator.language.split('-')[0]
    return AllowedLanguages.includes(userLang) ? userLang : DefaultLang
}

export default getUserLang;
